<template>
  <v-dialog v-model="value" width="500">
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        {{ header }}
        <v-spacer />
        <v-btn icon @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-progress-linear
          v-if="loading"
          indeterminate
          height="2"
          value="15"
          color="primary"
        ></v-progress-linear>
        <v-list>
          <v-list-item v-for="item in items" :key="item.id">
            {{ item.title }}
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["value", "items", "loading", "header"],
};
</script>
